import { ListOptionState } from '../shared/UiStates/TriStateCheckbox';

export type IabVendorModels = {
  name: string;
};

export type NonIabVendorModels = {
  name: string;
};

export enum VendorSelectionType {
  Purposes,
  LegitimateInterest,
}

export class VendorModel {
  public constructor(init?: Partial<VendorModel>) {
    Object.assign(this, init);
  }
  isIabVendor: boolean;

  vendorId: number;
  name: string;
  policyUrl: string;
  cookieMaxAgeSeconds: number;

  purposeIds?: Array<number>;
  legIntPurposeIds?: Array<number>;
  specialPurposeIds?: Array<number>;
  featureIds?: Array<number>;
  specialFeatureIds?: Array<number>;

  isEssential?: boolean;

  selections?: VendorSelectionType[] = [];

  public getToggleOptions(): VendorSelectionType[] {
    const options = [];
    if (this.purposeIds?.length > 0 ?? false) options.push(VendorSelectionType.Purposes);
    if (this.legIntPurposeIds?.length > 0 ?? false) options.push(VendorSelectionType.LegitimateInterest);
    return options;
  }

  public getToggleState(): ListOptionState {
    const options = this.getToggleOptions();
    const selections = this.selections ?? [];
    if (options.length === selections.length) return ListOptionState.all;
    if (selections.length === 0) return ListOptionState.none;
    if (selections.length > 0 && selections.length < options.length) return ListOptionState.some;
  }

  public ToggleSelection(selectionType: VendorSelectionType): VendorModel {
    if (this.isSelected(selectionType)) {
      this.selections = this.selections.filter((s) => s !== selectionType);
    } else {
      this.selections.push(selectionType);
    }
    return this;
  }

  public OptAllIn(): void {
    this.selections = this.getToggleOptions();
  }

  public isSelected(selectionType: VendorSelectionType): boolean {
    return this.selections?.indexOf(selectionType) >= 0 ?? false;
  }
}

export class VendorModels {
  constructor(models?: VendorModel[]) {
    this.models = (models ?? []).map((vendor) => new VendorModel({ ...vendor }));
  }

  models: VendorModel[];

  public SetAllVendorsOn(): VendorModels {
    const models = this.models.map((v) => {
      const newVendor = new VendorModel(v);
      newVendor.selections = v.getToggleOptions();
      return newVendor;
    });

    return new VendorModels(models);
  }

  public GetOptInStatus(): ListOptionState {
    const status = this.models
      .filter((v) => !(v.isEssential ?? false))
      .map((v) => v.getToggleState() === ListOptionState.all);

    const maxOptIn = status.length;
    const currentOptedIn = status.filter((s) => s === true).length;
    if (currentOptedIn === maxOptIn) return ListOptionState.all;
    if (currentOptedIn > 0) return ListOptionState.some;

    return ListOptionState.none;
  }

  public OptAllIn(): VendorModels {
    const newVendorModels = this.models.map((m) => {
      const newModel = new VendorModel({ ...m });
      newModel.OptAllIn();
      return newModel;
    });
    
    return new VendorModels(newVendorModels);
  }

  public Total(): number {
    return this.models.length;
  }
}
